
import { Divider, message, Popconfirm } from 'antd';
import React from 'react'
import { postFrom } from '../../axios';
import { API_merchant_findAll } from '../../axios/config';
import TableHelper from '../../components/TableHelper'
import {
    fetchTransferRecordLogList,
    fetchTransferRecordLogSftpUpload,
    fetchTransferRecordReminderList
} from '../../services/transferRecordLog'
import {findDict, formatTime, moneyAddComma} from '../../utils'
import PageWrap from '../../components/PageWrap';
import AuthButton from '../../components/AuthButton/AuthButton';
import moment from "moment";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-24 16:26:06
 * @LastEditTime: 2021-12-24 16:26:43
 * @LastEditors: zhao - 🍉
 * @Description: 划账记录
 * @FilePath: /zhzj-admin/src/page/TransferRecordLog/index.jsx
 */
class TransferRecordLog extends React.Component{
    constructor() {
        super()
        this.state = {
            merchantList: []
        }
    }
    componentDidMount() {
        this.postMerchantList()
    }

    handleEdit = (id) => {
        // this.TransferRecordUpdateRef.open(id).then(() => {
        //     this.TableHelperRef.postDataSource()
        // })
    }

    handleDetail = (id) => {
       // this.TransferRecordDetailRef.open(id)
    }
    //对账记录详情
    handleAccountingRecordDetail = (id) => {
       // this.AccountingRecordDetailRef.open(id)
    }

    handleOpenFlowApproval = (id) => {

    }
    handleOpenFlowList = (id) => {
      //  this.TransferRecordFlowListModalRef.open(id)
    }

    handleSftpUpload = (id) => {
       // this.postSftpUpload({transferRecordLogId: id})
    }

    postMerchantList() {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                let merchantList = res.map((item) => ({
                    title: item.shortName,
                    value: item.id,
                    name: item.name,
                    isJr: item.isJr,
                    zjbDataSync: item.zjbDataSync,
                }));
                this.setState({ merchantList });
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
            });
    }

    postSftpUpload(data) {
        return fetchTransferRecordLogSftpUpload(data).then(() => {
            message.success('操作成功')
        })
    }
  
    render(){
        const mapFlowStatus = [
            { title: '通过', value: 1 },
            { title: '不通过', value: 2 },
            { title: '待审核', value: 3 },
        ]

        const mapTransferRecordStatus = [
            { title: '待审核', value: 1 },
            { title: '审核中', value: 2 },
            { title: '审核未通过', value: 3 },
            { title: '待支付', value: 4 },
            { title: '处理中', value: 5 },
            { title: '划付成功', value: 6 },
            { title: '划付失败', value: 7 },
            { title: '划分文件上传失败', value: 8 },
            { title: '部分分账成功', value: 9 },
        ]
        const mapTransferRecordType = [
            { title: '云贷费用', value: 1 },
            { title: '业主租金', value: 2 },
            { title: '平台运营费用', value: 3 },
            { title: '商户结余退款', value: 4 },
            { title: '其他费用', value: 5 },

        ]
        const mapInstructionType = [
            { title: '银联分账', value: 1 },
            { title: '银联划付', value: 2 },
        ]

        const columns = [
            { title: '结算日期', dataIndex: 'executionTime' , render(text, record, index) {
                    return <span>
                <div>{text ? moment(text).format('YYYY-MM-DD') : ''}</div>
                        {record.overdueDays > 0 ? <div style={{ color: 'red' }}>逾期{record.overdueDays}天</div> :record.overdueDays === 0? null: <div style={{ color: 'red' }}>剩余{Math.abs(record.overdueDays)}天</div>}
                </span>
                }},
            { title: '费用名称', dataIndex: 'expenseName' },
            { title: '金额（元）', dataIndex: 'collectionAmount' },
            { title: '当前期数', dataIndex: 'number' },
            { title: '总期数', dataIndex: 'totalNumber'},
            { title: '商户简称', dataIndex: 'shortName' },
        ]
        const searchOptions = [
            { key: 'merchantId', type: 'select', placeholder: '商户', options: this.state.merchantList },
        ]
        return (
            <PageWrap>
                <TableHelper
                    ref={ref => this.TableHelperRef = ref}
                    columns={columns}
                    searchOptions={searchOptions}
                    request={fetchTransferRecordReminderList}
                    scroll={{x:1400}}
                >
                    <div slot="search">
                    </div>
                </TableHelper>
            </PageWrap>
            
        )
    }
}

export default TransferRecordLog


// WEBPACK FOOTER //
// ./src/page/TransferRecordReminder/index.jsx